export var ImageCarSizes;
(function (ImageCarSizes) {
    ImageCarSizes["xsmall"] = "xsmall";
    ImageCarSizes["small"] = "small";
    ImageCarSizes["medium"] = "medium";
    ImageCarSizes["large"] = "large";
    ImageCarSizes["xlarge"] = "xlarge";
    ImageCarSizes["huge"] = "huge";
})(ImageCarSizes || (ImageCarSizes = {}));
export var ImageCarBorderRadius;
(function (ImageCarBorderRadius) {
    ImageCarBorderRadius["all"] = "all";
    ImageCarBorderRadius["none"] = "none";
    ImageCarBorderRadius["top"] = "top";
    ImageCarBorderRadius["left"] = "left";
})(ImageCarBorderRadius || (ImageCarBorderRadius = {}));
//# sourceMappingURL=constants.js.map